module.exports = require("npm:ieee754@1.1.6/index.js");